"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Star, Clock, ShieldCheck, CircleCheck as CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
const vehicles = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_lincoln_mkt_limo.png",
  make: "Lincoln",
  model: "MKT Stretch Limousine",
  capacity: "8–10 Passengers",
  useCases: "Weddings, proms, night out",
  features: "Fiber optic lighting, bar service, privacy partition",
  businessValue: "Classic luxury for special events",
  minimum: "4–6 hours"
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_hummer_limo_stretch.png",
  make: "Hummer Limousine",
  model: "Stretch Limousine",
  capacity: "14–18 Passengers",
  useCases: "Bachelor parties, large group celebrations",
  features: "Premium sound system, multiple TV screens, disco floor",
  businessValue: "High-demand for large party groups",
  minimum: "5–8 hours"
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_hummer_h2_super_stretch.png",
  make: "Hummer",
  model: "H2 Super Stretch",
  capacity: "18–22 Passengers",
  useCases: "Concerts, sporting events, large parties",
  features: "Rugged exterior, spacious interior, neon lighting",
  businessValue: "Iconic presence for high-profile events",
  minimum: "6–8 hours"
}, {
  id: 4,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_mercedes_sprinter_limo.png",
  make: "Mercedes-Benz",
  model: "Sprinter Limo Van",
  capacity: "10–14 Passengers",
  useCases: "Corporate retreats, wine tours, VIP transport",
  features: "Standing room, luxury captain chairs, high ceiling",
  businessValue: "Versatile and highly profitable",
  minimum: "5–8 hours"
}, {
  id: 5,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_bmw_7_series_executive.png",
  make: "BMW",
  model: "7 Series Executive",
  capacity: "2–3 Passengers",
  useCases: "Executive travel, airport transfers",
  features: "Rear-seat entertainment, climate control, smooth ride",
  businessValue: "Perfect for corporate contracts",
  minimum: "2–4 hours"
}, {
  id: 6,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_chevrolet_suburban_suv.png",
  make: "Chevrolet",
  model: "Suburban SUV",
  capacity: "6–7 Passengers",
  useCases: "Family travel, airport runs, small groups",
  features: "Extra luggage space, premium leather, 4WD",
  businessValue: "Reliable workhorse for daily operations",
  minimum: "3–5 hours"
}, {
  id: 7,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_mini_coach_party_bus.png",
  make: "Mini Coach Bus",
  model: "Executive Party Bus",
  capacity: "25–30 Passengers",
  useCases: "Corporate events, large weddings",
  features: "Dance pole, restroom, full bar, lounge seating",
  businessValue: "Maximum revenue per booking",
  minimum: "6–8 hours"
}, {
  id: 8,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_rolls_royce_phantom.png",
  make: "Rolls-Royce",
  model: "Phantom (Vintage)",
  capacity: "2–3 Passengers",
  useCases: "Wedding getaway car, photo shoots",
  features: "Classic styling, wool carpets, wood trim",
  businessValue: "Premium niche for luxury weddings",
  minimum: "4 hours"
}, {
  id: 9,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_tesla_model_x.png",
  make: "Tesla",
  model: "Model X",
  capacity: "4–5 Passengers",
  useCases: "Eco-conscious VIPs, tech executives",
  features: "Falcon wing doors, silent electric drive, autopilot",
  businessValue: "Modern appeal for green-focused clients",
  minimum: "3–5 hours"
}, {
  id: 10,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_ford_f550_mini_coach.png",
  make: "Ford",
  model: "F-550 Mini Coach",
  capacity: "30–35 Passengers",
  useCases: "Shuttle services, long-distance group travel",
  features: "Reclining seats, overhead storage, PA system",
  businessValue: "Ideal for high-volume group transport",
  minimum: "5–8 hours"
}];
export default function VehicleGallery() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="vehicle-gallery" className="section-padding bg-background text-foreground px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6 text-primary">
            Our Premium Fleet
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto font-sans">
            Experience the pinnacle of Los Angeles luxury transportation. From executive sedans to high-capacity party buses, our meticulously maintained fleet ensures comfort, safety, and style for every occasion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {vehicles.map((vehicle, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll({
            threshold: 0.15
          });
          return <div key={vehicle.id} ref={ref} data-index={i} className={`transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            transitionDelay: `${i % 4 * 100}ms`
          }}>
                <Card className="h-full glass-effect border-muted overflow-hidden hover-lift flex flex-col bg-white/10 backdrop-blur-lg">
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img src={vehicle.image} data-wvc-srcset={`${vehicle.image}-wvc-srcset`} data-wvc-sizes={`${vehicle.image}-wvc-sizes`} alt={`${vehicle.make} ${vehicle.model}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                    <div className="absolute top-4 right-4 bg-primary/90 backdrop-blur-md text-black px-3 py-1 rounded-sm text-sm font-bold flex items-center gap-1.5">
                      <Users className="size-4" />
                      {vehicle.capacity}
                    </div>
                  </div>

                  <CardHeader className="pb-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="text-primary font-bold text-xs uppercase tracking-widest mb-1">{vehicle.make}</p>
                        <CardTitle className="text-xl text-foreground font-heading">{vehicle.model}</CardTitle>
                      </div>
                    </div>
                  </CardHeader>

                  <CardContent className="flex-grow space-y-4">
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="mt-1 p-1 bg-primary/10 rounded-sm">
                          <Star className="size-3.5 text-primary" />
                        </div>
                        <div>
                          <p className="text-[10px] font-bold text-muted-foreground uppercase">Best For</p>
                          <p className="text-xs text-foreground/80 line-clamp-2">{vehicle.useCases}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="mt-1 p-1 bg-primary/10 rounded-sm">
                          <Clock className="size-3.5 text-primary" />
                        </div>
                        <div>
                          <p className="text-[10px] font-bold text-muted-foreground uppercase">Minimum</p>
                          <p className="text-xs text-foreground/80">{vehicle.minimum}</p>
                        </div>
                      </div>
                    </div>

                    <div className="pt-4 border-t border-muted">
                      <p className="text-[10px] font-bold text-muted-foreground uppercase mb-2 flex items-center gap-2">
                        <ShieldCheck className="size-3.5 text-primary" />
                        Features
                      </p>
                      <ul className="grid grid-cols-1 gap-1.5">
                        {vehicle.features.split(', ').slice(0, 3).map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-[11px] text-foreground/70">
                            <CheckCircle2 className="size-3 text-primary shrink-0" />
                            <span className="truncate">{feature}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="pt-4 mt-auto">
                      <Link to="/ReservationsPage" className="btn-primary w-full group py-3 text-xs">
                        Book Now
                        <ArrowRight className="ml-2 size-3.5 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-20 text-center">
          <div className="inline-flex flex-col md:flex-row items-center gap-8 p-10 glass-effect border-muted rounded-lg bg-white/5 backdrop-blur-xl">
            <div className="text-left">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">Need a Custom Solution?</h3>
              <p className="text-muted-foreground max-w-md">Our fleet coordinators can help you select the perfect vehicle for your specific needs and group size.</p>
            </div>
            <Link to="/ContactPage" className="btn-secondary whitespace-nowrap">
              Contact Fleet Manager
            </Link>
          </div>
        </div>
      </div>
    </section>;
}